export const LOCAL_STORAGE = {
    BIZX_ACCESS_TOKEN: 'bizx_access_token',
    BIZX_LOCATION: 'bizx_location',
    BIZX_LOCATION_DETAILS: 'bizx_location_details',
    MAIN_NAVIGATION: 'main_navigation',
    IS_BATCH_ENABLED: "is_batch_enabled",
    REPORT_NAVIGATION: "report_navigation"
}